import React, { memo, useMemo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, bool, func, instanceOf, number, object, shape, string } from 'prop-types'

import TreeRow from './Components/TreeRow/TreeRow'

function TreeNode({
  node,
  positionById,
  actions,
  activeId = null,
  depth = 0,
  hasNextSibling = false,
}) {
  const { variation, children, isMuted } = node
  const id = String(variation.id)
  const style = useMemo(() => ({ '--variations-tree-depth': depth }), [depth])

  return (
    <li
      className={classnames(
        'variations-tree__node',
        depth > 0 && 'variations-tree__node--child',
        hasNextSibling && 'variations-tree__node--has-next',
      )}
      style={style}
    >
      <TreeRow
        variation={variation}
        position={positionById.get(id)}
        isActive={id === activeId}
        isMuted={isMuted}
        {...actions}
      />
      {children.length > 0 && (
        <ul className="variations-tree__children">
          {children.map((child, index) => (
            <TreeNode
              key={child.variation.id}
              node={child}
              positionById={positionById}
              actions={actions}
              activeId={activeId}
              depth={depth + 1}
              hasNextSibling={index < children.length - 1}
            />
          ))}
        </ul>
      )}
    </li>
  )
}

TreeNode.propTypes = {
  node: shape({
    variation: object.isRequired,
    children: arrayOf(object).isRequired,
    isMuted: bool.isRequired,
  }).isRequired,
  positionById: instanceOf(Map).isRequired,
  actions: shape({
    isActionLoading: bool.isRequired,
    onSetAsMain: func.isRequired,
    onDelete: func.isRequired,
  }).isRequired,
  activeId: string,
  depth: number,
  hasNextSibling: bool,
}

export default memo(TreeNode)
